import React from "react";
import MedleafBasePage from "./BasePage";
import CategoryBar from "src/core/products/components/v2/CategoryBar";
import BrandProductsBrowser from "src/core/products/components/BrandProductsList";
import useBrand from "src/core/products/hooks/useBrand";
import {PageHead} from "src/core/seo/components/Head";
import useRouter from "src/core/common/hooks/useRouter";
import {htmlToText} from "html-to-text";
import BrandDetailSchema from "src/core/seo/components/BrandDetailSchema";

export default function MedleafBrandPage() {
  const router = useRouter();
  const brandSlug = router.query["brand"];
  const [brand] = useBrand(brandSlug);

  return (
    <MedleafBasePage>
      {brand && (
        <PageHead
          title={brand.getName()}
          description={htmlToText(brand.getDescription())}
          image={brand.getLogo()}
          schemas={<BrandDetailSchema brand={brand} />}
        />
      )}
      <CategoryBar />
      <BrandProductsBrowser />
    </MedleafBasePage>
  );
}
